import { EdgeMap } from "./Components/Search/Feed/FeedItem/FeedItem"
import { EdgeKind } from "./PostContext"

export const getReplyKeys = (map?: EdgeMap) => {
  return Object.entries(map ?? {})
    .filter((entry) => entry[1].edgeKind === EdgeKind.REPLY)
    .map((e) => e[0])
}
